import PageHeader from '../../components/layout/PageHeader';
import ReviewQueue from '../../components/workflow/ReviewQueue';

/**
 * Agent's review queue — cases waiting for the current agent's action.
 *
 * Filter strategy: scope server-side to states where the agent has edit
 * permission AND assigned to me OR unassigned. The "Only my action"
 * checkbox in the shared component refines this further at the UI level
 * via the `needs_my_action` flag, but the default filter already trims
 * the result to a manageable list.
 */
export default function AgentReviewQueue(): JSX.Element {
  return (
    <>
      <PageHeader
        title="Review queue"
        subtitle="Cases waiting on you — KYC submissions to review and contracts uploaded by your members."
      />
      <ReviewQueue
        defaultFilters={{
          assigned_to: 'me',
          // Two workflows surface here:
          //   contract_review_v1 → uploaded, returned_to_agent
          //   onboarding_retail  → under_review (KYC docs ready for review)
          state_slug: ['uploaded', 'returned_to_agent', 'under_review'],
        }}
        detailPathPattern="/agent/cases/{caseId}"
        emptyHint="No cases waiting on you. New uploads from your members will appear here."
      />
    </>
  );
}
